"use client";

import Skeleton from "@/components/ui/Skeleton";
import useLightOrDarkText from "@/hooks/useLightOrDarkText";
import { ProductCard } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import clsx from "clsx";
import { Suspense } from "react";
import Price from "../Price";
import WishlistToggle from "../WishlistToggle/WishlistToggle";
import styles from "./index.module.css";

type Props = {
  id: string;
  product: ProductCard;
  hex?: string;
  className?: string;
  fullWidthMobile?: boolean;
};

const ProductDescription = ({
  id,
  product,
  className,
  hex,
  fullWidthMobile,
}: Props) => {
  const { description, core } = product || {};
  const color = useLightOrDarkText(hex || "");

  return (
    <div className={clsx(styles.description, className, hex && styles[color])}>
      <div>
        <p className={styles.product__material}>{description?.name}</p>
        <>
          <div className={styles.swatch_container}>
            <span
              className={clsx(styles.swatch)}
              style={{
                background: description?.swatch?.hex,
              }}
            />
            <p>{core?.variantName}</p>
          </div>
        </>
        <div className={styles.product__meta}>
          <Suspense fallback={<Skeleton height="16px" />}>
            <Price
              prices={description?.price}
              className={clsx(styles.product__price, "uppercase", "truncate")}
            />
          </Suspense>
        </div>
      </div>
      <div
        className={clsx(
          styles.wishlist_toggle,
          fullWidthMobile && styles.fullWidth,
        )}
      >
        <WishlistToggle
          className={clsx(hex && styles[color])}
          isDark={color === "dark"}
          id={id}
        />
      </div>
    </div>
  );
};

export default ProductDescription;
